import React, { useState } from 'react'
import styled from '@emotion/styled'
import { Box } from '../Box/Box'
import { Stack } from '../Stack/Stack'
import { Inline } from '../Inline/Inline'
import { Text } from '../Text/Text'
import { Icon } from '../Icon/Icon'

export interface AccordionProps {
  title: string
  children: React.ReactNode
  color?: string
}

export const Accordion: React.FC<AccordionProps> = ({
  title,
  children,
  color = 'var(--card--background)'
}) => {
  const [open, setOpen] = useState(false)

  return (
    <Box background={color} inset="m" radius="m">
      <Box onClick={() => setOpen(!open)} cursor="pointer">
        <Inline alignX="between" alignY="center" nowrap>
          <Text weight="stronger" size="big" component="p">
            {title}
          </Text>
          <Icon name="arrow" tone="action" rotate={open ? 180 : 0} />
        </Inline>
      </Box>
      {open && <Content space="m">{children}</Content>}
    </Box>
  )
}

const Content = styled(Stack)`
  white-space: pre-wrap;
`
